import { useEffect, useState } from "react";
import axiosInstance from "../helpers/axiosInstance";
import { useParams, useNavigate } from "react-router-dom";
import "bootstrap-icons/font/bootstrap-icons.css";

const ViewShop = () => {
    const { id } = useParams();
    const [shop, setShop] = useState(null);
    const [bays, setBays] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [baysToShow, setBaysToShow] = useState(2);
    const [showMore, setShowMore] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchShopDetails = async () => {
            try {
                const response = await axiosInstance.get(`/api/shop/shops/${id}`);
                setShop(response.data);
            } catch (err) {
                setError("Failed to fetch vendor details.");
                console.error("Error:", err);
            } finally {
                setLoading(false);
            }
        };

        fetchShopDetails();
    }, [id]);

    useEffect(() => {
        if (id) {
            axiosInstance.get(`/api/bays/${id}/bays`)
                .then(response => {
                    setBays(response.data.bays);
                })
                .catch(error => {
                    console.error("Failed to fetch bays:", error);
                });
        }
    }, [id]);

    const getStatusColor = (status) => {
        switch (status) {
            case "occupied":
                return "bg-success-subtle text-success";
            case "planned_empty":
                return "bg-warning-subtle text-warning";
            case "not_planned_occupied":
                return "bg-danger-subtle text-danger";
            default:
                return "bg-secondary-subtle text-secondary";
        }
    };

    const handleToggleView = () => {
        setShowMore(!showMore);
        setBaysToShow(showMore ? 2 : bays.length);
    };


    if (loading) return <p>Loading shop details...</p>;
    if (error) return <p className="text-red-500">{error}</p>;

    return (
        <div className="vendor-details-container m-4">
            <div className="device-details-card">
                <div className="device-header">
                    <div className="device-info">
                        <div className="info-grid">
                            <div className="info-item">
                                <span className="info-label">Shop Name</span>
                                <h1 className="device-name">
                                    <i className="bi bi-shop"></i>{shop?.shop_name}
                                </h1>
                            </div>
                            <div className="info-item">
                                <span className="info-label">Business Unit</span>
                                <div className="device-type">
                                    <i className="bi-grid-1x2"></i>{shop?.BusinessUnit?.unit_name}
                                </div>
                            </div>
                        </div>

                        <span className={`status-badge ${shop?.is_active ? "active" : "inactive"}`}>
                            {shop?.is_active ? "ACTIVE" : "INACTIVE"}
                        </span>
                    </div>
                </div>

                <div className="gap-2">
                    <h2
                        className="bay-title mt-3 ms-4"
                        style={{
                            fontSize: "20px",
                            fontWeight: 600,
                            color: "#333",
                        }}
                    >
                        <i
                            className="bi bi-info-circle me-2"
                            style={{ fontSize: "22px", color: "#007bff" }}
                        ></i>
                        Bay Overview
                    </h2>

                    <div
                        style={{
                            maxHeight: "400px",
                            overflowY: "auto",
                            overflowX: "hidden",
                        }}
                    >
                        {bays.slice(0, baysToShow).map((bay) => (
                            <div
                                key={bay.id}
                                className="row align-items-center shadow-sm rounded p-3 mb-3"
                            >
                                <div className="col-md-4 text-start ms-4">
                                    <span className="text-muted small">Bay Number</span>
                                    <h5 className="fw-bold mb-0 mt-2 ms-4">{bay.number}</h5>
                                </div>

                                <div className="col-md-3 text-center">
                                    <span
                                        className={`badge px-3 py-2 fw-semibold ${getStatusColor(
                                            bay.status
                                        )}`}
                                    >
                                        {bay.status.replaceAll("_", " ")}
                                    </span>
                                </div>

                                <div className="col-md-4 text-end ms-5">
                                    <a
                                        href={`/bay/${bay.id}`}
                                        className="text-decoration-underline text-primary "
                                    >
                                        View Details
                                        <i className="bi bi-box-arrow-up-right ms-2"></i>
                                    </a>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {bays.length > 2 && (
                <div className="text-center mt-3">
                    <button className="btn btn-link" onClick={handleToggleView}>
                        {showMore ? "View Less" : "View More"}
                    </button>
                </div>
            )}

            <div className="actions-section mt-0 border-0">
                <button className="back-button" onClick={() => navigate(-1)}>
                    <i className="bi bi-arrow-left"></i>
                    Back to Shops
                </button>
            </div>
        </div>
    );
};

export default ViewShop;
